window.SiteReady(($) => {

  console.log('Init Block: Locations Grid');

  const $grids = $('.js-locations_grid');

  $grids.each((_, grid) => {
    const $grid = $(grid);
    const $items = $grid.find('.js-locations_item');
    const $map = $grid.find('.js-region_map');

    function onMouseEnter(e) {
      const $item = $(e.currentTarget);
      const id = $item.data('marker-id');
      const $marker = $(id);

      $map.find('.jvm-marker').removeClass('hover');
      $marker.addClass('hover');
    }

    function onMouseLeave(e) {
      $map.find('.jvm-marker').removeClass('hover');
    }

    $items
      .on('mouseenter', onMouseEnter)
      .on('mouseleave', onMouseLeave);
  });

});